import React, { useEffect, useState } from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../../../../helpers';


const DynamicForm = ({formId}) => {

  const [formEntries, setFormEntries] = useState([
    { condition: '', output: '', action: '', annotation: '', secondCondition:'' }
  ]);


  const groupByCondition = (items) => {
    return items.reduce((acc, item) => {
      const key = item.condition;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
  };
  
  const [decide, setDecide] = useState([])

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newFormEntries = [...formEntries];
    newFormEntries[index][name] = value;
    setFormEntries(newFormEntries);
  };


  const handleAddForm = () => {
    setFormEntries([...formEntries, { condition: '', output: '', action: '', annotation: '' }]);
  };


  const handleRemoveForm = (index) => {
    const newFormEntries = formEntries.filter((_, i) => i !== index);
    setFormEntries(newFormEntries);
  };


  const fetchData = async ()=>{
    try{
      const data = await axios.get(rootUrl(`/api/FamilyPlaning/Get-Form-Decision/${formId}`))

      if(Array.isArray(data.data)){
        setDecide(data.data.map(res=>res.decisiondata))
      }

      
    }catch(e){
      toast.error(e?.message)
    }
  }

  const [expandedCondition, setExpandedCondition] = useState(null);
  const groupedItems = groupByCondition(decide);
  const toggleAccordion = (condition) => {
    setExpandedCondition(expandedCondition === condition ? null : condition);
  };


  useEffect(()=>{
    fetchData()
  },[])


  const handleSubmit = async (event) => {
    event.preventDefault();
    try{

      const response = await axios.post(rootUrl(`/api/FamilyPlaning/Decision-support/${formId}`),formEntries)
      toast.success(response.data.message)
      setFormEntries([{ condition: '', output: '', action: '', annotation: '' }]);
      fetchData()
    }catch(e){
      toast.error(e?.message)
    }



  };

  return (
    <div>

<div className="container mx-auto my-4">
<div className="w-full">

  <span className="bg-blue-700 px-2 py-1 text-white rounded-full text-sm m-3">
  {decide.length} {decide.length === 1 ? 'Total DSS' : 'Total DSS'}
              </span>
      {Object.entries(groupedItems).map(([condition, items]) => (
        <div key={condition} className="my-2 border border-gray-300 rounded-lg">
          <div
            className="flex justify-between items-center p-4  cursor-pointer"
            onClick={() => toggleAccordion(condition)}
          >
            <div className="flex items-center space-x-4">
              <span className="text-lg font-semibold">{condition}</span>
              <span className="bg-blue-700 px-2 py-1 text-white rounded-full text-sm">
                {items.length} {items.length === 1 ? 'DSS' : 'DSS'}
              </span>
            </div>
            <svg
              className={`w-6 h-6 transform transition-transform ${
                expandedCondition === condition ? 'rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {expandedCondition === condition && (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white">
                <thead>
                  <tr className='bg-gray-100'>
                    <th className="py-2 px-4 border-b text-left">Sno.</th>
                    <th className="py-2 px-4 border-b text-left">2nd condition</th>
                    <th className="py-2 px-4 border-b text-left">Output</th>
                    <th className="py-2 px-4 border-b text-left">Action</th>
                    <th className="py-2 px-4 border-b text-left">Annotation</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td className="py-2 px-4 border-b">{++index}</td>
                      <td className="py-2 px-4 border-b">{item.secondCondition}</td>
                      <td className="py-2 px-4 border-b">{item.output}</td>
                      <td className="py-2 px-4 border-b">{item.action}</td>
                      <td className="py-2 px-4 border-b">{item.annotation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
    </div>
    <form onSubmit={handleSubmit}>
      {formEntries.map((entry, index) => (
        <div key={index} className="flex items-center">
          <input
            type="text"
            name="condition"
            value={entry.condition}
            onChange={(event) => handleInputChange(index, event)}
            placeholder="Condition"
            className="p-2 border rounded-md font-normal focus:outline-none focus:border-blue-500 m-2"
          />
        <input
            type="text"
            name="secondCondition"
            value={entry.secondCondition}
            onChange={(event) => handleInputChange(index, event)}
            placeholder="2nd condition"
            className="p-2 border rounded-md font-normal focus:outline-none focus:border-blue-500 m-2"
          />
          <input
            type="text"
            name="output"
            value={entry.output}
            onChange={(event) => handleInputChange(index, event)}
            placeholder="Output"
            className="p-2 border rounded-md font-normal focus:outline-none focus:border-blue-500 m-2"
          />
          <input
            type="text"
            name="action"
            value={entry.action}
            onChange={(event) => handleInputChange(index, event)}
            placeholder="Action"
            className="p-2 border rounded-md font-normal focus:outline-none focus:border-blue-500 m-2"
          />
          <input
            type="text"
            name="annotation"
            value={entry.annotation}
            onChange={(event) => handleInputChange(index, event)}
            placeholder="Annotation"
            className="p-2 border rounded-md font-normal focus:outline-none focus:border-blue-500 m-2"
          />
          <button type="button" onClick={() => handleRemoveForm(index)} className="bg-red-500 py-2 px-8 text-center text-white flex items-center">
            <FaMinus/>
          </button>
        </div>
      ))}
        <div className='flex justify-center'>
      <button type="button" onClick={handleAddForm} className="bg-blue-500 mb-2 py-2 px-8 text-center text-white flex items-center">
          <FaPlus/>
      </button>
      </div>
      <hr className='my-3'/>
      <div className='flex justify-center'>
      <button type="submit" className="bg-green-500 py-2 px-8 text-center text-white flex items-center">
        Submit
      </button>
      </div>
     
    </form>
    </div>
  );
};

export default DynamicForm;